import axios from "axios";
import api from "../../../Axios";
 

const API_URL = `${process.env.REACT_APP_BASE_URL}/api/v1/news`;

// Upload News (with PDF file)
export const uploadNews = async (formData) => {
  try {
    const response = await api.post(API_URL, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("Error uploading news:", error);
    throw error;
  }
};

// Get All News
export const getNews = async () => {
  try {
    const response = await api.get(API_URL);
    return response.data.newsList;
  } catch (error) {
    console.error("Error fetching news:", error);
    throw error;
  }
};

// Delete News
export const deleteNews = async (id) => {
  try {
    await api.delete(`${API_URL}/${id}`);
    return true;
  } catch (error) {
    console.error("Error deleting news:", error);
    throw error;
  }
};
